// extracted by mini-css-extract-plugin
var _1 = "kdrAxgohulvDMZdHaWZV";
var _2 = "e1ZRQ82yRV3PjgN94X4W";
var _3 = "NzvcrALDRXQgO3FF4ypb";
export { _1 as "grid", _2 as "img", _3 as "name" }
